/* eslint-disable import/no-commonjs */

const docsearch = require('./src/lib/main').default;
module.exports = docsearch;
